import ActionTypes from '../action-types';
import { onFulfill, onPending, onReject } from '../util/actions';
import { CALL_STATUS, RECORDING_STATUS } from '../../../Constants';

const initialState = {
  callId: null,
  callStatus: CALL_STATUS.INITIATED.code,
  recordingStatus: null,
  recordingStatusLoading: false
};

export default (state = initialState, action = {}) => {
  const { payload, type } = action;

  switch (type) {
    case onPending(ActionTypes.START_RECORDING):
      return {
        ...state,
        recordingStatusLoading: true
      };
    case onFulfill(ActionTypes.START_RECORDING):
      return {
        ...state,
        recordingStatus: RECORDING_STATUS.INPROGRESS,
        recordingStatusLoading: false
      };
    case onReject(ActionTypes.START_RECORDING):
      return {
        ...state,
        recordingStatus: null,
        recordingStatusLoading: false
      };
    case onPending(ActionTypes.STOP_RECORDING):
      return {
        ...state,
        recordingStatusLoading: true
      };
    case onFulfill(ActionTypes.STOP_RECORDING):
      return {
        ...state,
        recordingStatus: RECORDING_STATUS.COMPLETED,
        recordingStatusLoading: false
      };
    case onReject(ActionTypes.STOP_RECORDING):
      return {
        ...state,
        recordingStatusLoading: false
      };
    case onPending(ActionTypes.GET_CALL):
      return {
        ...state
      };

    case onReject(ActionTypes.GET_CALL):
      return {
        ...state,
        callId: null,
        callStatus: null,
        recordingStatus: null
      };

    case onFulfill(ActionTypes.GET_CALL):
      return {
        ...state,
        callId: payload ? payload.taskCallId : null,
        callStatus: payload ? payload.callStatus : null,
        recordingStatus: payload ? payload.recordingStatus : null
      };

    case onFulfill(ActionTypes.START_CALL):
    case onFulfill(ActionTypes.GET_CALL_ID):
      return {
        ...state,
        callId: payload ? payload.taskCallId : null
      };

    case onFulfill(ActionTypes.STOP_CALL):
    case ActionTypes.COMPLETE_CALL:
      return initialState;

    default:
      return state;
  }
};
